import { t } from "i18next";
import { Computer, Tablet, Mobile } from "neetoicons";

export const RESPONSIVE_DEVICES = {
  DESKTOP: "desktop",
  TABLET: "tablet",
  MOBILE: "mobile",
};

export const RESPONSIVE_DEVICES_MAP = {
  [RESPONSIVE_DEVICES.DESKTOP]: {
    icon: Computer,
    label: t("neetoMolecules.responsiveDevicePicker.desktop"),
  },
  [RESPONSIVE_DEVICES.TABLET]: {
    icon: Tablet,
    label: t("neetoMolecules.responsiveDevicePicker.tablet"),
  },
  [RESPONSIVE_DEVICES.MOBILE]: {
    icon: Mobile,
    label: t("neetoMolecules.responsiveDevicePicker.mobile"),
  },
};
